import {
  REQUEST_ERROR,
  REQUEST_START,
  REQUEST_SUCCESS
} from '../../../../../middlewares/api/actions';
import {
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ,
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_HIDE,
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ,
  LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_SHOW,
  LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET,
  LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_HIDE,
  LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ,
  LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_SHOW,
  LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ,
  LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_HIDE,
  LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_SHOW
} from './actions';
import {getCubesTree} from "../../../../../utils/treeBuilders";
import {
  getCategorisedObjectsTree,
  getFilteredTreeWithPaths,
  getMappedTree
} from "../../../../../utils/tree";

const loaderCsvFormMappingControlReducer = (
  state = {
    isSelectedMappingVisible: false,
    isMappingsVisible: false,
    mappingsTree: null,
    detailMappingId: null,
    detailMapping: null,
    detailMappingCube: null
  },
  action
) => {
  switch (action.type) {
    case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET:
      return {
        ...state,
        isMappingsVisible: false
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_SHOW:
      return {
        ...state,
        isMappingsVisible: true
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_SHOW:
      return {
        ...state,
        detailMappingId: action.mappingId
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_SHOW:
      return {
        ...state,
        isSelectedMappingVisible: true
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_HIDE:
      return {
        ...state,
        isMappingsVisible: false,
        mappingsTree: null,
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_HIDE:
      return {
        ...state,
        detailMappingId: null,
        detailMapping: null,
        detailMappingCube: null
      };
    case LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_HIDE:
      return {
        ...state,
        isSelectedMappingVisible: false
      };
    case REQUEST_START: {
      switch (action.label) {
        case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ:
          return {
            ...state,
            mappingsTree: null
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ:
          return {
            ...state,
            detailMapping: null
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ:
          return {
            ...state,
            detailMappingCube: null
          };
        default:
          return state;
      }
    }
    case REQUEST_ERROR: {
      switch (action.label) {
        case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ:
          return {
            ...state,
            isMappingsVisible: false
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ:
          return {
            ...state,
            detailMappingId: null
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ:
          return {
            ...state,
            isSelectedMappingVisible: false
          };
        default:
          return state;
      }
    }
    case REQUEST_SUCCESS: {
      switch (action.label) {
        case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPINGS_READ:

          const [allCubes, dcs, mappings] = action.response;

          const treeWithCategories = getCubesTree(allCubes, dcs);

          const treeWithCategoriesOrd = getMappedTree(treeWithCategories, "children", node => {
            let ordCount = 1;
            return {
              ...node,
              TreeID: node.CatCode ? `Cat_${node.CatCode}` : `${node.Code}`,
              children:
                node.children
                  ? node.children
                    .sort((a, b) => {
                      if (a.Ord !== undefined && b.Ord !== undefined) {
                        return a.Ord - b.Ord;
                      } else if (a.Ord !== undefined) {
                        return a;
                      } else if (b.Ord !== undefined) {
                        return b;
                      } else {
                        return (a.CatCode || -1) - (b.CatCode || -1);
                      }
                    })
                    .map(c => ({
                      ...c,
                      Ord: c.Ord !== undefined ? String(ordCount++) : undefined
                    }))
                  : node.children
            };
          });

          const treeWithMappings = getCategorisedObjectsTree(
            mappings.map(mapping => ({
              ...mapping,
              TreeID: `Mapp_${mapping.IDMapping}`
            })),
            treeWithCategoriesOrd,
            "children",
            (a, b) => a.IDMapping - b.IDMapping,
            (mapping, cube) => {
              if (cube) {
                return cube.IDCube === mapping.IDCube;
              } else {
                return true;
              }
            },
            null,
            null,
            true
          );

          const cleanedTreeWithMappings = getFilteredTreeWithPaths(
            treeWithMappings,
            "children",
            node =>
              node.IDMapping ||
              (node.children && node.children.filter(({IDMapping}) => IDMapping).length > 0)
          );

          return {
            ...state,
            mappingsTree: cleanedTreeWithMappings
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_READ:
          return {
            ...state,
            detailMapping: action.response
          };
        case LOADER_CSV_FORM_MAPPING_CONTROL_DETAIL_MAPPING_CUBE_READ:
          return {
            ...state,
            detailMappingCube: action.response
          };
        default:
          return state;
      }
    }
    default:
      return state;
  }
};

export default loaderCsvFormMappingControlReducer;



// WEBPACK FOOTER //
// ./src/scenes/data-manager/loader/csv-form/mapping-control/reducer.js